import React, { useEffect, useContext } from "react";
import styled from "styled-components";

import AddSongFlow from "../../../service/add-song-flow";
import ToastService from "../../../service/toast-service";
import PlaylistService from "../../../service/playlist-service";
import { Box, Row, Text, Img, HGap, Fab, OptionButton } from "../../../comps";
import MaterialIconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../../theme/theme-provider";

import { faHeart as faEmptyHeart } from "@fortawesome/free-regular-svg-icons";
import {
  faPlay,
  faTrashAlt,
  faHeart,
  faList,
  faPlus,
  faImages,
  faEllipsisV,
} from "@fortawesome/free-solid-svg-icons";

const GridItem = styled.div`
  height: 60px;
  width: 100%;
  display: block;
  box-sizing: border-box;
  transition: opacity 0.3s;
`;

const SongWrapper = styled(Row)`
  width: 100%;
  height: 100%;
  align-items: center;
  margin: 5px;
  padding-left: 40px;
  padding-right: 40px;
  @media ${({ theme }) => theme.screenSize.portrait} {
    padding-left: 10px;
    padding-right: 10px;
  }
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_1};
  &:hover {
    background: #45413d;
  }
`;

const Name = styled(Text)`
  margin-left: ${({ marginLeft }) => marginLeft};
  width: 50%;
`;

const Right = styled(Row)`
  width: 30%;
  height: 100%;
  align-items: center;
  margin-left: auto;
`;

const PlayButton = styled(Box)`
  margin-right: 5%;
  display: none;
  ${SongWrapper}:hover & {
    display: block;
  }
`;

export default ({
  song,
  saved,
  onSaveChange,
  onDelete,
  handlePlay,
  setAsTheme,
  handleAddToQueue,
}) => {
  const { videoId, title, thumbnails } = song;

  return (
    <GridItem className={"item"}>
      <div class="item-content">
        <SongWrapper>
          <Img
            width={16 * 5}
            height={9 * 5}
            src={
              (thumbnails &&
                (thumbnails.mediumUrl || thumbnails.standardUrl)) ||
              ""
            }
          />
          <Text
            width="50%"
            oneline={true}
            fontSize={"16px"}
            fontWeight={300}
            marginLeft={"6%"}
          >
            {title}
          </Text>
          <HGap style={{ marginLeft: "auto" }} width="0px" />
          <PlayButton onClick={handlePlay}>
            <Fab
              faIcon={faPlay}
              backgroundColor={Theme.color.BLUE_4}
              iconColor="#fff"
              elevation={false}
            />
          </PlayButton>
          <HGap style={{ marginLeft: "5%" }} width="0px" />
          <OptionButton
            optionBackground={Theme.color.BLUE_4}
            isIconButton={true}
            color="#fff"
            icon={faEllipsisV}
            options={[
              {
                icon: faList,
                text: "Add To Queue",
                onClick: handleAddToQueue,
              },
              {
                icon: faPlus,
                text: "Add To Playlist",
                onClick: () => {
                  AddSongFlow.initiateAddToPlaylist({ songs: [song] });
                },
              },
              {
                icon: faImages,
                text: "Set as thumbnail",
                onClick: setAsTheme,
              },
            ]}
          />
          <MaterialIconButton
            onClick={onSaveChange}
            style={{ marginLeft: "5%" }}
          >
            <FontAwesomeIcon
              style={{
                color: saved ? Theme.color.BLUE_5 : Theme.color.WHITE_2,
                fontSize: "16px",
              }}
              icon={saved ? faHeart : faEmptyHeart}
            />
          </MaterialIconButton>
          <MaterialIconButton onClick={onDelete} style={{ marginLeft: "5%" }}>
            <FontAwesomeIcon
              style={{ color: Theme.color.WHITE_2, fontSize: "16px" }}
              icon={faTrashAlt}
            />
          </MaterialIconButton>
        </SongWrapper>
      </div>
    </GridItem>
  );
};
